export default __webpack_public_path__ + "static/threads_te_2-9c4c95772c2e32028a55ee3f9a844b20.jpg";